import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table'
import { antiNameHandler } from 'module/anti_name_handler';
import strings from '../../strings/strings.json'

interface Props {
    data: any
    scan_result: any
}

export default function MalwareTable(props: Props) {
    const columns: ColumnsType<any> = [
        {
            title: strings.public_antiName,
            dataIndex: 'antiname',
            key: 'antiname',
            align: 'center',
            render: (value, item, index) =>
                <div className='text-base flex justify-center items-center'>
                    <img className='w-6 h-6 mr-2' src={require(`../../assets/icons/${(item.av_name !== undefined && antiNameHandler(props.data ? item.av_name : item) !== 'Unknown') ? item.av_name : 'question'}.png`)} alt="Icon" />
                    <span>{antiNameHandler(props.data ? item.av_name : item)}</span>
                </div>
        },
        {
            title: strings.public_malwareName,
            dataIndex: 'malwarename',
            key: 'malwarename',
            align: 'center',
            render: (value, item, index) => <span className={`VazirEng flex justify-center ${props.data ? 'text-red-500' : 'text-green-500'}`}>{props.data ? item.malware_name : '-'}</span>
        },
    ]

    return (
        <div className='mt-10' dir='ltr'>
            <Table
                columns={columns}
                dataSource={props.data ? props.data : props.scan_result.avs}
                rowClassName='text-sm md:text-base'
                size='middle'
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </div>
    )
}
